<template>
  <div id="mdznads-interstitial-wrapper" ref="mainWrapper" style="z-index: 987945247; visibility: hidden; width: 100%; display: flex">
    <div style="background-color: #ffffff; padding: 6px; border-radius: 6px; overflow-x: hidden">
      <div id="mdznads-interstitial-header">
        <div id="mdznads-interstitial-logo">
          <img
            src="https://srv-cdn.onedio.com/store/06d7c2c95eb3a9575a24f175bfec121ff9bae3b20b4d36cdb5c52a2e3789efa5.png"
            style="width: 55px"
          />
        </div>
        <div
          id="mdznads-interstitial-close-button"
          ref="closeButton"
          style="width: 22px; height: 22px; color: #424242; cursor: pointer; display: none"
          @click="closeWrapper"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-6">
            <path
              fill-rule="evenodd"
              d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z"
              clip-rule="evenodd"
            />
          </svg>
        </div>
      </div>
      <div id="custom-interstitial"></div>
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted, ref, onBeforeUnmount, useContext, useRoute, inject } from '@nuxtjs/composition-api';
import { useDevice } from '@/composables/useDevice';
import { commonAdUnits } from '../constants/units/common';
import { createGPTSlot, callPrebid, createPrebidAdUnit } from '../utils/utils';
import { onedioEvents } from '~/modules/tracking/scripts/onedioEvents';
export default defineComponent({
  setup() {
    const adMode = inject('adConfig', {});
    const { $cookies } = useContext();
    const route = useRoute();
    const { isMobile } = useDevice();
    const { sendAdEvent } = onedioEvents();
    const mainWrapper = ref(null);
    const closeButton = ref(null);
    const checkParams = ref(route?.value?.query?.noreferrer !== undefined || !!route?.value?.query?.google_preview || false);
    let timeoutId = null;

    const unlockScroll = () => document.getElementsByTagName('body')[0].classList.remove('no-scroll');
    const lockScroll = () => document.getElementsByTagName('body')[0].classList.add('no-scroll');

    const setCloseButtonView = () => {
      let timeLapse = 3;
      const interval = setInterval(function () {
        timeLapse--;
        if (timeLapse < 1) {
          clearInterval(interval);
          closeButton.value.style.display = 'block';
        }
      }, 1000);
    };

    const closeWrapper = () => {
      unlockScroll();
      sendAdEvent('Popup Ad', 'close_click', 'Interstitial');
      mainWrapper.value.style.display = 'none';
    };

    const handleReferrer = (customInterstitial) => {
      const includes =
        customInterstitial.referrer.include && customInterstitial.referrer.include.some((value) => document.referrer.includes(value));
      if (checkParams.value) {
        return true;
      } else {
        return includes;
      }
    };

    const shouldShowInterstitial = () => {
      const lastShown = $cookies.get('mdznads-custom-interstitial');
      const now = Date.now();
      if (!lastShown || now - lastShown > 2000 * 1000) {
        return true;
      }
      return false;
    };

    const isSponsored = () => {
      return !adMode.value?.sponsoredTag?.isSponsored && !['sponsored', 'PremiumUser', 'noAds'].includes(adMode.value?.decidedMode?.value);
    };

    onMounted(() => {
      const customInterstitial = commonAdUnits[isMobile.value ? 'mobile' : 'desktop'].customIntersitial;
      if (handleReferrer(customInterstitial) && isSponsored()) {
        if (!shouldShowInterstitial()) return false;
        window.googletag = window.googletag || { cmd: [] };
        const googletag = window.googletag;
        googletag.cmd.push(function () {
          const slot = createGPTSlot(customInterstitial, 'custom-interstitial', adMode.value?.targetings);
          window.pbjs.que.push(function () {
            window.pbjs.addAdUnits([createPrebidAdUnit(customInterstitial)]);
          });
          callPrebid(slot);
          googletag.pubads().addEventListener('slotRenderEnded', (event) => {
            if (event.slot.getAdUnitPath() === slot.getAdUnitPath() && !event.isEmpty) {
              timeoutId = setTimeout(() => {
                !checkParams.value &&
                  $cookies.set('mdznads-custom-interstitial', Date.now(), {
                    path: '/',
                    expires: 0,
                  });
                mainWrapper.value.style.visibility = 'visible';
                lockScroll();
                setCloseButtonView();
              }, 3000);
            }
          });
        });
      }
    });

    onBeforeUnmount(() => {
      if (timeoutId) clearTimeout(timeoutId);
    });

    return { mainWrapper, closeButton, closeWrapper };
  },
});
</script>

<style>
#mdznads-interstitial-wrapper {
  font-family: sans-serif;
  position: fixed;
  inset: 0px;
  width: auto;
  height: 100%;
  opacity: 1;
  display: none;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.55) !important;
}

#mdznads-interstitial-wrapper > div {
  position: relative;
  max-width: 100%;
  max-height: 100%;
}

@media all and (max-width: 450px) {
  #mdznads-interstitial-wrapper {
    padding-inline: 5px;
  }
}

#mdznads-interstitial-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 24px;
  border-bottom: 1px solid #dfdfdf;
  margin-bottom: 3px;
}

#mdznads-interstitial-logo {
  padding-left: 6px;
}
</style>
